export default "__VITE_ASSET__CUV$jRXT__"